import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { BiData, } from '@wix/da-bi/pkg/events';
import { ReferralType, BiEventType } from '@wix/da-bi/pkg/constants';
import StandardMenu from '../../../../Dropdown/MenuPreset/StandardMenu';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { useDeviationAttributes } from '../../../../DeviationViews/hooks/useDeviationAttributes';
import { useRestrictToLoggedIn } from '../../../../utils/hooks/useRestrictToLoggedIn';
import s from './MoreMenuContent.scss';
// This is used only on desktop
var MoreMenuContent = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner, _b = _a.closeTooltip, closeTooltip = _b === void 0 ? function () { return null; } : _b, showReportModal = _a.showReportModal, showDesktopDeviationSharePopup = _a.showDesktopDeviationSharePopup, showNftLinkPopup = _a.showNftLinkPopup, shareDeviationToPost = _a.shareDeviationToPost;
    var nftDeviationEdit = useFlag('nft_deviation_edit');
    var kill_prints_act_two = useFlag('kill_prints_act_two');
    var t = useTranslation().t;
    var restrictToLoggedIn = useRestrictToLoggedIn().restrictToLoggedIn;
    var _c = useDeviationAttributes(deviation, isOwner), isPrintPurchasable = _c.isPrintPurchasable, isShareable = _c.isShareable, isReportable = _c.isReportable, hasNft = _c.hasNft;
    var pcp_update_dev_page = useFlag('pcp_update_dev_page');
    var _d = deviation.print, _e = _d === void 0 ? {} : _d, lowestPrice = _e.lowestPrice, purchaseUrl = _e.purchaseUrl;
    var isIncludingPrintPurchase = isPrintPurchasable &&
        !!purchaseUrl &&
        pcp_update_dev_page &&
        !kill_prints_act_two;
    var printLinkLabel = lowestPrice
        ? t('actionbar.buyPrintsFor', { price: lowestPrice })
        : t('actionbar.buyPrints');
    return (React.createElement(StandardMenu, { className: s['menu'], id: "actionbar-more-menu", items: [
            isShareable && {
                value: 'share',
                label: t('actionbar.share'),
                biData: BiData({
                    evid: 355,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    deviationid: deviation.deviationId,
                }),
                onClick: showDesktopDeviationSharePopup,
            },
            isShareable && {
                value: 'shareToPost',
                label: t('actionbar.shareToPost'),
                onClick: restrictToLoggedIn(ReferralType.SHARE_TO_POST, function () {
                    return shareDeviationToPost(deviation);
                }),
                biData: BiData({
                    evid: 356,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    social_share: 'da_post',
                    deviationid: deviation.deviationId,
                }),
            },
            isIncludingPrintPurchase && {
                value: 'printPurchase',
                label: printLinkLabel,
                biData: {
                    evid: BiEventType.BUY_CLICK,
                    deviationid: deviation.deviationId,
                },
                link: purchaseUrl,
            },
            isReportable && {
                value: 'report',
                label: t('actionbar.report'),
                biData: BiData({
                    evid: 20,
                    modal_version: 2,
                    deviationid: deviation.deviationId,
                }),
                onClick: function () {
                    showReportModal(deviation);
                    closeTooltip();
                },
            },
            nftDeviationEdit &&
                !hasNft &&
                isOwner && {
                value: 'linknft',
                label: t('actionbar.linkNft'),
                onClick: function () {
                    showNftLinkPopup(deviation);
                    closeTooltip();
                },
            },
        ] }));
};
MoreMenuContent.displayName = 'MoreMenuContent';
export default MoreMenuContent;
//# sourceMappingURL=MoreMenuContent.js.map